
var env = {
    getStripePublicKey: function() {
        var publicKey = "";
        if (process.env.BROWSER) {
            publicKey = window.stripe_pk;
        }
        return publicKey;
    },

    getBaseUrl: function() {
        var url = "";
        if (process.env.BROWSER) {
            if (window && window.location) {
                url = window.location.protocol + '//' + window.location.host + '/';
            }
        }
        return url;
    }
};

exports.env = env;